import { useState } from "react";

import { ChevronDown } from "@assets/svg/ChevronDown";
import { BodySmall } from "@components/Typography";
import { useTheme } from "@hooks";
import { useStyles } from "./styles";
import { ExpandableCardProps } from "./types";

export const ExpandableCard = ({ title, expanded = false, children }: ExpandableCardProps) => {
  const styles = useStyles();
  const { theme } = useTheme();
  const [isExpanded, setIsExpanded] = useState(expanded);

  return (
    <div style={styles.container}>
      <button type="button" style={styles.header} onClick={() => setIsExpanded((v) => !v)}>
        <BodySmall style={{ ...styles.title, color: theme.text.secondary }}>{title}</BodySmall>
        <span
          style={{
            ...styles.chevronWrap,
            ...(isExpanded ? styles.chevronOpen : {}),
          }}
        >
          <ChevronDown size={24} />
        </span>
      </button>

      <div
        style={{
          ...styles.expandGrid,
          ...(isExpanded ? styles.expandGridOpen : styles.expandGridClosed),
        }}
      >
        <div style={styles.expandInner}>{children}</div>
      </div>
    </div>
  );
};
